import { useQuery } from '@tanstack/react-query';
import { QualityIssueListsSchema, type CrmListValueDto } from '@taqon/contracts';
import { getData } from '../../shared/api/client';

export const QUALITY_ISSUES = '/api/v1/quality/issues';

/** The category and severity lists (SDD §15.3); both are business configuration. */
export function useQualityLists() {
  return useQuery({
    queryKey: ['quality', 'lists'],
    queryFn: () => getData('/api/v1/quality/issue-lists', QualityIssueListsSchema),
  });
}

/** A list value's label, or the stored code when the value is no longer in the list. */
export function listLabel(
  values: readonly CrmListValueDto[] | undefined,
  code: string | null,
): string {
  if (code === null) return '—';
  return values?.find((value) => value.valueCode === code)?.label ?? code;
}

export const ACTION_TYPE_LABELS = { corrective: 'Corrective', preventive: 'Preventive' } as const;
